import { Component, OnInit,Input } from '@angular/core';
import * as Chart from 'chart.js'


@Component({
  selector: 'app-seller-revenue',
  templateUrl: './seller-revenue.component.html',
  styleUrls: ['./seller-revenue.component.css']
})
export class SellerRevenueComponent implements OnInit {

  @Input() graphData;

  constructor() { }

  ngOnInit(){

  }

  title = 'Seller Revenue';
  canvas: any;
  ctx: any;
  ngAfterViewInit() {

    var labels = []
    var dataset = []

    
    var ar = []
    

  
    
    for (let data in this.graphData){
      labels.push(this.graphData[data].name);
      dataset.push(this.graphData[data].percentage);
    }
    

    this.canvas = document.getElementById('sellerRevenueChart');
    this.ctx = this.canvas.getContext('2d');
    let myChart = new Chart(this.ctx, {
      type: 'pie',
      data: {
          labels: labels,
          datasets: [{
              label: 'Test',
              data: dataset,
              backgroundColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(60, 159, 64, 1)',
                'rgba(60, 255, 64, 1)',
                'rgba(60, 66, 255, 1)',
                'rgba(150, 160, 160, 1)',
                'rgba(255, 255, 66, 1)',
                'rgba(255, 66, 255, 1)',                                
                'rgba(30, 30, 30, 1)',
                'rgba(150, 150, 90, 1)',
                'rgba(150, 160, 160, 1)',
                'rgba(200, 1, 1, 1)',
                'rgba(17,82, 37, 1)',
                'rgba(172,17, 17, 1)',
                'rgba(17,167, 172, 1)',
                'rgba(152,254, 98, 1)',
                'rgba(98,254, 142, 1)',
                'rgba(239,254, 98, 1)',
                'rgba(254,119, 98, 1)',
                'rgba(98,171, 254, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
              ],
              borderWidth: 1
          }]
      },
      options: {        
        responsive: false,
        display:true,
        maintainAspectRatio: true,
        title: {
          enabled : true,
          text : "Comparación revenue entre hermanos", 
        },
        legend: {
          position: "right",
          labels: {
            generateLabels: function(chart) {
                var data = chart.data;
                if (data.labels.length && data.datasets.length) {
                    return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var ds = data.datasets[0];
                        var arc = meta.data[i];
                        var custom = arc && arc.custom || {};
                        var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                        var arcOpts = chart.options.elements.arc;
                        var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                        var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                        var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                        // We get the value of the current label
                        var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];

                        return {
                            // Instead of `text: label,`
                            // We add the value to the string
                            text: label + " : "+ value+"%",
                            fillStyle: fill,
                            strokeStyle: stroke,
                            lineWidth: bw,
                            hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                            index: i
                        };
                    });
                } else {
                    return [];
                }
            }
        }  
        },
        
      }
    });
  }
}
